import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteClient } from "api/client.api";
import {
  invalidateClientSide,
  invalidateDashboardSources,
} from "lib/cacheInvalidation";

export const useDeleteClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteClient,
    onSuccess: () => {
      invalidateClientSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
